import { render, staticRenderFns } from "./EmailNotificationSettings.vue?vue&type=template&id=b750f298&scoped=true&"
import script from "./EmailNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationSettings.vue?vue&type=style&index=0&id=b750f298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b750f298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
